import { useCallback, useEffect } from "react";
import Header from "../../landingPage/Header";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../../landingPage/Footer";
import { useDispatch, useSelector } from "react-redux";
import { fetchParentsStudents } from "../../../redux/features/parentStudentsSlice";
import { auth } from "../../../config/firebaseConfig";

const ParentDashboardLayout = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isCodeWorkspace = location.pathname.includes("/dashboard/code-workspace");

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const { userDetails: parentsDetails } = useSelector((state) => state.auth);

  // fetch participants registered for the school
  const fetchStudents = useCallback(() => {
    try {
      parentsDetails &&
        dispatch(
          fetchParentsStudents({
            parentUid:
              parentsDetails?.id ||
              parentsDetails?.uid ||
              auth?.currentUser?.uid,
          })
        )
          .unwrap()
          .catch((error) => {
            throw new Error(error.message);
          });
    } catch (err) {
      console.log(err);
    }
  }, [dispatch, parentsDetails]);

  useEffect(() => {
    const unsub = parentsDetails ? fetchStudents() : () => { };
    return () => unsub?.();
  }, [parentsDetails, fetchStudents]);

  return (
    <div>
      <Header placement="dashboard" dashboard="parent" />
      <div className="parents-dashbaord">
        <Outlet />
      </div>
      {!isCodeWorkspace && <Footer />}
    </div>
  );
};

export default ParentDashboardLayout;
